export default "__VITE_ASSET__DTFb4xJv__"